<template>
  <a-layout v-if="!isOaeRoute" id="components-layout-demo-fixed" >
    <Banner />
    <a-layout-content
      :style="{ padding: '0 50px', marginTop: '64px', height: '100%' }"
    >
      <router-view></router-view>
      <!-- <div :style="{ background: 'white', padding: '24px', minHeight: '380px' }">
        <Content/>
      </div> -->
    </a-layout-content>
    <a-layout-footer
      :style="{ textAlign: 'center', backgroundColor: '#3b5998' }"
    >
      <Map />
      <div>Copyright © 2024</div>
      <!-- <div>渝ICP备2022013486号-2</div> -->
    </a-layout-footer>
  </a-layout>
  <div v-else>
    <router-view></router-view>
  </div>
</template>
<script>
import Banner from './components/banner.vue';
import Map from './components/Mymap.vue';
// import Content from './components/occurContent/occurcontent.vue'
export default {
  name: 'AppName',
  components: {
    Banner,
    Map,
  },
  computed: {
    isOaeRoute() {
      return this.$route.path === '/pad';
    }
  }
};
</script>
<style scoped>
#components-layout-demo-fixed {
  height: fit-content;
}
#components-layout-demo-fixed .logo {
  width: 120px;
  height: 31px;
  background: rgb(255, 255, 255);
  margin: 16px 24px 16px 0;
  float: left;
}
.ant-layout {
  background-color: white;
}
</style>
